<section class="conselheiros-estatisticas">
    <div class="conselheiros-topo">
        <app-card-content title="Antecedência média de agendamento" subtitle="Diferença média entre o registro do agendamento e o horário previsto da reunião (não mede o horário real de início)" icon="pi pi-clock">
            <div class="estatistica-total-bloco">
                <span class="estatistica-total-valor">{{ variacaoFormatada }}</span>
                <span class="estatistica-total-label">{{ variacaoTotalReunioes }} reuniões</span>
            </div>
        </app-card-content>

        <app-card-content title="Conselheiros mais atuantes" subtitle="Top 10 por presenças (P+V)" icon="pi pi-star">
            <div class="grafico-wrap">
                <p-chart type="bar" [data]="graficoAtuantes" [options]="opcoesGrafico"></p-chart>
            </div>
        </app-card-content>

        <app-card-content title="Conselheiros por faltas" subtitle="Top 10 por ausências (A)" icon="pi pi-user-minus">
            <div class="grafico-wrap">
                <p-chart type="bar" [data]="graficoFaltas" [options]="opcoesGrafico"></p-chart>
            </div>
        </app-card-content>
    </div>

    <app-card-content title="Atuação dos conselheiros" subtitle="Presenças, faltas e comissões por conselheiro" icon="pi pi-id-card">
        <p-table
            [value]="linhas"
            [lazy]="true"
            (onLazyLoad)="carregarTabela($event)"
            [paginator]="true"
            [rows]="rows"
            [totalRecords]="totalRegistros"
            [first]="first"
            [loading]="carregandoTabela"
            [rowsPerPageOptions]="[20, 50, 100]"
            sortMode="single"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="nmSolicitante">Conselheiro</th>
                    <th>UF</th>
                    <th>CRM</th>
                    <th pSortableColumn="presenciais">Presenciais</th>
                    <th pSortableColumn="remotas">Virtuais</th>
                    <th pSortableColumn="faltas">Faltas</th>
                    <th>Justificadas</th>
                    <th pSortableColumn="totalPresencas">Total</th>
                    <th>% compar.</th>
                    <th pSortableColumn="qtdComissoes">Comissões</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-linha>
                <tr>
                    <td>{{ linha.nmSolicitante }}</td>
                    <td>{{ linha.ufSgUf }}</td>
                    <td>{{ linha.nuCrm }}</td>
                    <td>{{ linha.presenciais }}</td>
                    <td>{{ linha.remotas }}</td>
                    <td>{{ linha.faltas }}</td>
                    <td>{{ linha.justificadas }}</td>
                    <td>{{ linha.totalPresencas }}</td>
                    <td>{{ linha.percentualComparecimento }}%</td>
                    <td>{{ linha.qtdComissoes }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="10">Nenhum conselheiro com atividade no período.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-card-content>
</section>
